import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    scoreSummaryRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    redBox: {
        backgroundColor: "red",
        height: 30,
        width: 40,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: "bold",
        border: "solid black 1px",
        borderRadius: 20,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    blueBox: {
        backgroundColor: "blue",
        height: 30,
        width: 40,
        marginLeft: 5,
        marginRight: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 14,
        fontWeight: "bold",
        border: "solid black 1px",
        borderRadius: 20,
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    },
    athletePositionBoxContainer: {
        display: 'flex',
        flexDirection: "row",
        alignItems: 'center'
    },
    positionOfScene: {
        ...theme.typography.h6,
        color: theme.palette.text.secondary
    }
}));

export {useStyles};